/**
 * Priority options for variations
 */
export const PRIORITY_OPTIONS = [
  { key: 'all', text: 'All', value: 'all' },
  { key: 'low', text: 'Low', value: 'low' },
  { key: 'medium', text: 'Medium', value: 'medium' },
  { key: 'high', text: 'High', value: 'high' },
  { key: 'urgent', text: 'Urgent', value: 'urgent' }
];

/**
 * Status options for variations
 */
export const STATUS_OPTIONS = [
  { key: 'all', text: 'All', value: 'all' },
  { key: 'new', text: 'New', value: 'new' },
  { key: 'not-started', text: 'Not Started', value: 'not-started' },
  { key: 'in-progress', text: 'In Progress', value: 'in-progress' },
  { key: 'review', text: 'Review', value: 'review' },
  { key: 'completed', text: 'Completed', value: 'completed' }
];

/**
 * Default priority value
 */
export const DEFAULT_PRIORITY = 'medium';

/**
 * Default status value
 */
export const DEFAULT_STATUS = 'not-started';

/**
 * Get color for priority
 * @param {string} priority - The priority value
 * @returns {string} The color for the priority
 */
export const getPriorityColor = (priority) => {
  switch (priority) {
    case 'low':
      return 'green';
    case 'medium':
      return 'blue';
    case 'high':
      return 'orange';
    case 'urgent':
      return 'red';
    default:
      return 'grey';
  }
};

/**
 * Get color for status
 * @param {string} status - The status value
 * @returns {string} The color for the status
 */
export const getStatusColor = (status) => {
  switch (status) {
    case 'new':
      return 'blue';
    case 'not-started':
      return 'grey';
    case 'in-progress':
      return 'blue';
    case 'review':
      return 'orange';
    case 'completed':
      return 'green';
    default:
      return 'grey';
  }
};
